let itm = {
  // bcg: require('../bcg_unit.png'),
  bcg2: require('./u7.png'),
  name: 'It’s lunchtime!',
  items: [],
};

export default itm;
